import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

import Period from '../../../../helpers/PeriodWeighted';
import WeightedItem from '../../../../helpers/WeightedTime'

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';

// Shared components
import PortletHeader from 'components/PortletHeader';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';

// Material components
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Popover from '@material-ui/core/Popover';
import CloseIcon from '@material-ui/icons/Close';

import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import HelpIcon from '@material-ui/icons/Help';
import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import {getWeighing} from '../../../../services/getWeighing'
import PerfectScrollbar from 'react-perfect-scrollbar';
import AvailabilityWeighted from './AvailabilityWeighted'
import ResponseWeighted from './ResponseWeighted'
import { api_auth} from '../../../../common/globals/constants';
// Component styles
import styles from './styles';

import moment from 'moment'
import 'moment/locale/es'
import { AtCircularProgress } from '../../../../components/AtCircularProgress';
import { Box, Card, CardContent, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
moment.locale('es')

class Weighted extends Component {
    
    constructor(props) {
        super(props);
        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        this.translation = (this.props && this.props.t) ? this.props.t : (s => s);
        var range=this.translation('text.range') +": "+(moment().locale('es')).format("YYYY-MM-DD")+" a "+(moment().locale('es')).format("YYYY-MM-DD")
        var rangePonderado=this.translation('text.period') +": "+(moment().locale('es')).subtract(1, "days").format("DD-MM-YYYY")+" al "+(moment().locale('es')).format("DD-MM-YYYY")
        this.state = {
            typeGraph: 0,
            client:sessionStorage.getItem("client_id"),
            token:sessionStorage.getItem("key"),
            period: "d",
            begin:(moment().subtract(1, "days").locale('es')).format("YYYY-MM-DD"),
            final:(moment().locale('es')).format("YYYY-MM-DD"),
            steps: this.props.location.state.fromObjective.Pasos,
            namePeriod: range,
            namePonderado:rangePonderado,
            objetive: this.props.match.params.objetivo_id,
            statePeriod: {},
            isStatePeriod: false,
            responseTimeGraphEl: null,
            periodEl: null,
            extendEl: null,
            nameGraph: [this.translation('monitoring.tools-section.weighted.modal.name-graph.0'), this.translation('monitoring.tools-section.weighted.modal.name-graph.1')],
            namePeriodPorlet: [this.translation('period.text.last-day'), this.translation('period.text.last-week'), this.translation('period.text.custom'), this.translation('period.text.last-3-days')],
            typePeriod: 0,
            settingsEl: null,
            settingsPop:null,
            settingWeighted:null,
            isInfo: null,
            detalleGraph:[this.translation('monitoring.tools-section.weighted.modal.detalle-graph.0'),
                        this.translation('monitoring.tools-section.weighted.modal.detalle-graph.1')],
            isLoad:true
        };
    }


    componentDidMount() {
        this.getPonderacion()
    }

    getPonderacion=()=>{
        const {token, client}=this.state
        //console.log(api_auth)
        var getWeight=getWeighing(client, token, api_auth)
        
        getWeight.then( value =>{
            var weighted=(value.slice(1,30))
            var weightedId=(value.slice(0,1))[0]
            //console.log(weightedId)
            //value=(value.filter((ele) => ele !== "ponderado_id"))
            //console.log(value)
            this.setState({
                Weighing:weighted,
                weightedId:weightedId,
                isLoad:false   
            });
        })
        
    }
    handlePeriodClick(prevPeriod, prevTypeGraph, statePeriod, nextPeriod) {
        const t = this.translation;
        //console.log(nextPeriod)
        if (nextPeriod === 'dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "d",
                typePeriod: 0,
                begin:(moment().subtract(1, "days").locale('es')).format("YYYY-MM-DD"),
                final:(moment().locale('es')).format("YYYY-MM-DD"),
                namePeriod: t('text.range') +": "+(moment().locale('es')).format("YYYY-MM-DD")+" a "+(moment().locale('es')).format("YYYY-MM-DD"),
                namePonderado: t('text.period') +": "+(moment().locale('es')).subtract(1, "days").format("DD-MM-YYYY")+" al "+(moment().locale('es')).format("DD-MM-YYYY"),
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === '3dia') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "3d",
                typePeriod: 3,
                begin:(moment().subtract(3, "days").locale('es')).format("YYYY-MM-DD"),
                final:(moment().locale('es')).format("YYYY-MM-DD"),
                namePeriod: t('text.range') +": "+(moment().locale('es')).subtract(3, "days").format("YYYY-MM-DD")+" a "+(moment().locale('es')).format("YYYY-MM-DD"),
                namePonderado: t('text.period') +": "+(moment().locale('es')).subtract(3, "days").format("DD-MM-YYYY")+" al "+(moment().locale('es')).format("DD-MM-YYYY"),
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
            });
        } else if (nextPeriod === 'semana') {
            this.setState({
                typeGraph: prevTypeGraph,
                period: "w",
                typePeriod: 1,
                begin:(moment().subtract(7, "days").locale('es')).format("YYYY-MM-DD"),
                final:(moment().locale('es')).format("YYYY-MM-DD"),
                namePeriod: t('text.range') +": "+(moment().locale('es')).subtract(1, "weeks").format("YYYY-MM-DD")+" a "+(moment().locale('es')).format("YYYY-MM-DD"),
                namePonderado: t('text.period') +": "+(moment().locale('es')).subtract(1, "weeks").format("DD-MM-YYYY")+" al "+(moment().locale('es')).format("DD-MM-YYYY"),
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'custom') {
            //console.log(statePeriod.startDate.toISOString().substring(0, 10),statePeriod.endDate.toISOString().substring(0, 10) )
            function sumarDias(fecha, dias){
                fecha.setDate(fecha.getDate() + dias);
                return fecha;
            }
            function restaDias(fecha, dias){
                fecha.setDate(fecha.getDate() - dias);
                return fecha;
            }
            var sumaDiaPerio = statePeriod.endDate;
            var diaActual = new Date();
            if(statePeriod.startDate.toISOString().substring(0, 10) == diaActual.toISOString().substring(0, 10)){
                this.setState({
                    typeGraph: prevTypeGraph,
                    period: "d",
                    typePeriod: 0,
                    begin:(moment().subtract(1, "days").locale('es')).format("YYYY-MM-DD"),
                    final:(moment().locale('es')).format("YYYY-MM-DD"),
                    namePeriod: t('text.range') +": "+(moment().locale('es')).format("YYYY-MM-DD")+" a "+(moment().locale('es')).format("YYYY-MM-DD"),
                    namePonderado: t('text.period') +": "+(moment().locale('es')).subtract(1, "days").format("DD-MM-YYYY")+" al "+(moment().locale('es')).format("DD-MM-YYYY"),
                    statePeriod: {},
                    isStatePeriod: false,
                    periodEl: null,
                    isRefresh: false
                });
            }
            else if(statePeriod.startDate.toISOString().substring(0, 10) == statePeriod.endDate.toISOString().substring(0, 10)){
                sumarDias(sumaDiaPerio, 1);
                this.setState({
                    typeGraph: prevTypeGraph,
                    period: "c",
                    begin:statePeriod.startDate.toISOString().substring(0, 10),
                    final:statePeriod.endDate.toISOString().substring(0, 10),
                    typePeriod: 2,
                    namePeriod: t('text.range') +": "+ statePeriod.startDate.toISOString().substring(0, 10) + ' a ' + statePeriod.endDate.toISOString().substring(0, 10),
                    namePonderado: t('text.period') +": "+ new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(statePeriod.startDate) + ' al ' + new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(restaDias(sumaDiaPerio, 1)),
                    statePeriod: statePeriod,
                    isStatePeriod: true,
                    periodEl: null,
                    isRefresh: false
                });
            }else{
                sumarDias(sumaDiaPerio, 1);
                this.setState({
                    typeGraph: prevTypeGraph,
                    period: "c",
                    begin:statePeriod.startDate.toISOString().substring(0, 10),
                    final:statePeriod.endDate.toISOString().substring(0, 10),
                    typePeriod: 2,
                    namePeriod: t('text.range') +": "+ statePeriod.startDate.toISOString().substring(0, 10) + ' a ' + statePeriod.endDate.toISOString().substring(0, 10),
                    namePonderado: t('text.period') +": "+ new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(statePeriod.startDate) + ' al ' + new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(restaDias(sumaDiaPerio, 1)),
                    statePeriod: statePeriod,
                    isStatePeriod: true,
                    periodEl: null,
                    isRefresh: false
                });
            }
        }
    }

    handleModalWeighted =event=>{
        this.setState({
            settingWeighted: event.currentTarget
        });
    }
    handleModalCloseWeighted = () => {
        this.setState({
            settingWeighted: null
        });
    };
    handlePopGraph = event => {
        this.setState({
            settingsPop: event.currentTarget
        });
    };
    handleClosePop = () => {
        this.setState({
            settingsPop: null
        });
    };
    handleShowSettings = event => {
        this.setState({
            settingsEl: event.currentTarget
        });
    };
    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };
    handleCloseSettings = () => {
        this.setState({
            settingsEl: null
        });
    };

    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };

    handleShowAvailability=()=>{
        this.setState({
            typeGraph: 0,
            settingsPop: null
        });
    }

    handleShowResponse=()=>{
        this.setState({
            typeGraph: 1,
            settingsPop: null
        });
    }

    handleClose = event => {

        this.props.onClose()
    };


    render() {
        const { classes } = this.props;
        const { typeGraph, period,namePonderado , periodEl, nameGraph, namePeriodPorlet,
            typePeriod, settingsEl, isInfo, detalleGraph, isLoad, settingsPop, settingWeighted} = this.state;

        const showSettingsPop = Boolean(settingsPop);
        const showSettingsWeighted = Boolean(settingWeighted);
        const showSettingsEl = Boolean(settingsEl);
        const showIsInfo = Boolean(isInfo);
        const showPeriodEl = Boolean(periodEl);
        const t = this.translation;
        if(isLoad===true){
            return (
                <Card>
                    <AtCircularProgress />
                </Card>
            )
            
        }else{
            return (
                <>                
                    <DialogTitle style={{padding: 0}}>
                        <PortletHeader style={{display: 'flex', justifyContent: 'space-between'}}>
                            <Box>
                                <Typography variant='h4' className='card__text--dark-color'>{nameGraph[typeGraph]}</Typography>
                            </Box>
                            <Box display='flex' flexDirection='row'>
                            <PortletToolbar style={{display: 'flex', justifyContent: 'end'}}>
                                <Popover
                                    anchorEl={settingWeighted}
                                    onClose={this.handleModalCloseWeighted}
                                    open={showSettingsWeighted}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                        }}
                                    >
                                    <WeightedItem weighted={this.state.Weighing} idWeighted={this.state.weightedId} />
                                </Popover>
                                <IconButton
                                    onClick={this.handlePopGraph}
                                >
                                    <Typography 
                                    color="infoIcon"
                                    variant="h5">{t('monitoring.tools-section.weighted.modal.select.label')} </Typography>
                                    <ArrowDropDownIcon />                                    
                                </IconButton>
                                
                                <Popover
                                    
                                    anchorEl={settingsPop}
                                    onClose={this.handleClosePop}
                                    open={showSettingsPop}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                        }}
                                        
                                    >
                                    <Grid container direction="column"  alignItems="center" >
                                        <Grid item xs={12} xl={12}>
                                            <IconButton
                                                onClick={this.handleShowAvailability}
                                            >
                                                <Typography variant="h6">{t('monitoring.tools-section.weighted.modal.select.option.availability')}</Typography>
                                            </IconButton>
                                        </Grid>
                                        <Grid item xs={12} xl={12}>
                                            <IconButton
                                                onClick={this.handleShowResponse}
                                            >
                                                <Typography variant="h6">{t('monitoring.tools-section.weighted.modal.select.option.performance')}</Typography>
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Popover>
                                <IconButton
                                    onClick={this.handleShowSettings}
                                >
                                    <SettingsOutlinedIcon />
                                    
                                </IconButton>
                                <Popover
                                    anchorEl={settingsEl}
                                    onClose={this.handleCloseSettings}
                                    open={showSettingsEl}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                        }}
                                    >
                                    <IconButton
                                        onClick={this.handleShowIsInfo}
                                        onClose={this.handleCloseIsInfo}
                                    >
                                        <div>
                                            <HelpIcon color="secondary"/><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>
                                                {t('monitoring.tools-section.weighted.modal.button.settings.tooltip')}
                                            </Typography>
                                        </div>
                                    </IconButton>
                                        <Popover
                                        anchorEl={isInfo}
                                        open={showIsInfo}
                                        onClose={this.handleCloseIsInfo}
                                        >
                                        <PortletContent variant="h4" style={{fontSize:'16px', color:'#66788A'}}>{detalleGraph[typeGraph]}</PortletContent>
                                    </Popover>
                                </Popover>
                            </PortletToolbar>
                            <IconButton aria-label="close" className={classes.buttonClosed} onClick={this.handleClose}><CloseIcon/></IconButton>
                            </Box>
                        </PortletHeader>
                    </DialogTitle>
                        <DialogContent>
                            <Graph typeGraph={typeGraph} data={this.state} />
                        </DialogContent>
                    <DialogActions style={{display: 'flex', justifyContent: 'start'}}>
                        <Box style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <Button onClick={this.handleShowPeriod}>
                                <Typography style={{color:'#66788A', fontWeight:"bold"}} variant="caption">
                                    {namePeriodPorlet[typePeriod]}
                                </Typography>
                                <ArrowDropDownIcon />
                            </Button>
                            <Popover
                                anchorEl={periodEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center'
                                }}
                                onClose={this.handleClosePeriod}
                                open={showPeriodEl}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center'
                                }}>
                                <Period onClick={this.handlePeriodClick} period={period} typeGraph={typeGraph} isOneHour={null}/>
                            </Popover>
                            <Typography style={{color:'#66788A', fontWeight:"bold"}} varian="caption">
                                        {namePonderado}
                            </Typography>
                        </Box>
                    </DialogActions>
                </>
            )
        }
    }
}

function Graph(props) {
    //console.log('props envio', props.data)
    const typeGraph = props.typeGraph;
    if (typeGraph === 0) {    
        return <AvailabilityWeighted period={props.data.typePeriod} objective={props.data.objetive} steps={props.data.steps} begin={props.data.begin} 
        final={props.data.final} range={props.data.range} namePeriod={props.data.period} Weighing={props.data.Weighing}/>;
    }else if (typeGraph === 1) {    
        return <ResponseWeighted period={props.data.typePeriod} objective={props.data.objetive} steps={props.data.steps} begin={props.data.begin} 
        final={props.data.final} range={props.data.range} namePeriod={props.data.period} Weighing={props.data.Weighing}/>;
    }
}
export default
    compose(withRouter, withStyles(styles), withTranslation())(Weighted);